import { getJobs, getProviders, getGovPrograms, getNgoPrograms, type JobListing, type Provider, type GovProgram, type NgoProgram } from '@/lib/accesshub'
import { fetchApprovedSubmissions, type ResourceSubmission } from '@/lib/resourceSubmissions'

export type { ResourceSubmission }

export interface FindHelpData {
  jobs: JobListing[]
  providers: Provider[]
  govPrograms: GovProgram[]
  ngoPrograms: NgoProgram[]
  approvedSubmissions: ResourceSubmission[]
}

let cachedFindHelpData: FindHelpData | null = null
let pendingFindHelpData: Promise<FindHelpData> | null = null

export function getCachedFindHelpData() {
  return cachedFindHelpData
}

export function invalidateFindHelpCache() {
  cachedFindHelpData = null
  pendingFindHelpData = null
}

export function prefetchFindHelpData() {
  if (cachedFindHelpData) return Promise.resolve(cachedFindHelpData)
  if (pendingFindHelpData) return pendingFindHelpData

  pendingFindHelpData = Promise.all([getJobs(), getProviders(), getGovPrograms(), getNgoPrograms(), fetchApprovedSubmissions()])
    .then(([jobs, providers, govPrograms, ngoPrograms, approvedSubmissions]) => {
      cachedFindHelpData = { jobs, providers, govPrograms, ngoPrograms, approvedSubmissions }
      return cachedFindHelpData
    })
    .finally(() => {
      pendingFindHelpData = null
    })

  return pendingFindHelpData
}
